var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 84,
    viewBox: "0 0 356 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.262 -165.635C394.22 -169.464 483.133 -168.789 547.371 -114.593C615.992 -56.6997 653.063 32.744 651.808 122.516C650.568 211.177 608.312 295.564 540.831 353.085C477.963 406.673 391.354 429.399 310.262 413.65C240.069 400.017 206.65 327.21 154.688 278.09C99.847 226.247 14.4711 196.992 2.28777 122.516C-10.8584 42.1536 34.3718 -38.278 93.8335 -93.9125C151.527 -147.892 231.336 -162.036 310.262 -165.635Z",
    fill: "url(#paint0_linear_1301_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1301_53",
    x1: 0,
    y1: 125.776,
    x2: 651.839,
    y2: 125.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0283C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753A88"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble7);
export default __webpack_public_path__ + "static/media/bubble_7.700dbc13322d263082981efcc4cfeda3.svg";
export { ForwardRef as ReactComponent };